"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var l = require("lenovo");
var translates = l.Translator.translate;
require("../sass/general-dialog.scss");
var LoadingDialog = /** @class */ (function (_super) {
    __extends(LoadingDialog, _super);
    function LoadingDialog(props) {
        return _super.call(this, props) || this;
    }
    LoadingDialog.prototype.render = function () {
        return React.createElement("div", { className: "dow-loading-overlay" },
            React.createElement("div", { className: "loading overlay" }));
    };
    return LoadingDialog;
}(React.Component));
exports.LoadingDialog = LoadingDialog;
var GeneralDialog = /** @class */ (function (_super) {
    __extends(GeneralDialog, _super);
    function GeneralDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.onClickButton = _this.onClickButton.bind(_this);
        return _this;
    }
    GeneralDialog.prototype.onClickButton = function (e) {
        var btn = e.target;
        var option = btn.dataset["option"];
        //option
        this.props.callback(option);
        //remove dialog
        var dialog = this.refs['dialog'];
        $(dialog).parent().empty();
    };
    GeneralDialog.prototype.render = function () {
        var _a = this.props, title = _a.title, msg = _a.msg, yesBtn = _a.yesBtn;
        return React.createElement("div", { ref: "dialog", className: "dow-general-dialog modal" },
            React.createElement("div", { className: "modal-dialog" },
                React.createElement("div", { className: "modal-content" },
                    React.createElement("div", { className: "header" },
                        React.createElement("span", { className: "title" }, title),
                        React.createElement("span", { className: "btn-close", "data-option": "no", onClick: this.onClickButton }, "\u00D7")),
                    React.createElement("div", { className: "body" },
                        React.createElement("span", { className: "message" }, msg),
                        React.createElement("a", { className: "btn-default btn btn-yes", "data-option": "yes", onClick: this.onClickButton, "data-dismiss": "modal" }, yesBtn)))));
    };
    return GeneralDialog;
}(React.Component));
exports.GeneralDialog = GeneralDialog;
